class Accisa {
    
    zone = [
        {
            scaglioni: [
                0.0440, 0.1750, 0.1700, 0.1860
            ]
        },
        {   // cassa del mezzogiorno
            scaglioni: [
                0.0380, 0.1350, 0.1200, 0.1500
            ]
        }
    ]

    getCluster( regione ){
        let zona = this.zone[0];
        switch (regione) {
            case 'Abruzzo':
            case 'Molise':
            case 'Basilicata':
            case 'Lazio':
            case 'Campania':
            case 'Calabria':
            case 'Sicilia':
            case "Sardegna":
                zona = this.zone[1];
            break;
            default:
                // do nothing we are already in the right zone
                break;
        }

        return zona;
    }

}
export default new Accisa();